export default {
  productCode: 'Product Code',
  productName: 'Product Name',
  plant: 'Plant',
  specialCode: 'Special Code',
  specialType: 'Special Type',
  exceptionType: 'Exception Type',
  createTime: 'Create Time',
  lastUpdatedBy: 'Last Updated By',
  lastUpdateTime: 'Last Update Time',
  disableConfirm:
    'The SKU will no longer use this Special code in tunnel validation. To use it again you must create a new record. Continue?',
  productCodeEnterHint: 'Press Enter to load product name',
  specialCodeSelectLabel: 'Special Code',
  mandatoryFields: 'Please complete all required fields before submitting.',
  errorcode_invalid_format: 'Invalid Product Code Format. Please verify it again. (e.g. IF0696-001)',
  errorcode_436: 'Invalid Product Code. Please verify it again. (e.g. IF0696-001)',
  errorcode_7003:
    'The Special code + Plant already exists. Please search for it on the page before making any edits or updates.'
}
